import React, {Component} from 'react';
import _ from 'lodash';

import JqDatePicker from '../../lib/mxjslib/mx.react.jquery-ui.datepicker.min';

import {Time} from '../../util';
import DatePickerSingle from './single';
import DatePickerSingleChk from './singleChk';


class DatePickerRange extends Component {
  render() {
    const {
      onStartSelect,
      onEndSelect,
      defaultStartDate,
      defaultEndDate,
    } = this.props;
    return (
      <div className='datepicker-container'>
        <DatePickerSingle onSelect={onStartSelect} defaultDate={defaultStartDate}/>
        ~
        <DatePickerSingle onSelect={onEndSelect} defaultDate={defaultEndDate}  />
      </div>
    );
  }
}

export default DatePickerRange;


// WEBPACK FOOTER //
// ./src/components/datepicker/range.js